import React from 'react';
import PropTypes from 'prop-types';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import messages from '../messages';
import { sumPoints } from '../helpers';
import {
  AssessmentItem,
  AssessmentHeader,
  DocIcon,
  AssessmentTitle,
  TagGroup,
  Tag,
  SoftTag,
  PrimaryTag,
  ChevronButton,
  ItemList,
  ItemRow,
  ItemMeta,
  ItemTitle,
  ItemUrn,
} from '../styles';
import { SVGIcon } from '@pearsontechnology/aero-components';
import { svgIconType } from 'Workspace/Publications/utils/constants';

const AssessmentRow = ({ assessment, items, isExpanded, onToggle }) => {
  const points = sumPoints(items);

  return (
    <AssessmentItem>
      <AssessmentHeader
        type="button"
        onClick={() => onToggle(assessment.assessmentId)}
        aria-expanded={isExpanded}
      >
        <DocIcon>
          <SVGIcon icon={svgIconType.CLIPBOARD_LIST} />
        </DocIcon>
        <AssessmentTitle>{assessment.title}</AssessmentTitle>
        <TagGroup>
          <SoftTag>{assessment.assessmentType}</SoftTag>
          <Tag>{intl.formatMessage(messages.itemsCount, { count: items.length })}</Tag>
          <Tag>{intl.formatMessage(messages.pointsCount, { count: points })}</Tag>
        </TagGroup>
        <ChevronButton expanded={isExpanded}>
          <SVGIcon icon={svgIconType.EXPAND_DOWN_ARROW} size="large" />
        </ChevronButton>
      </AssessmentHeader>

      {isExpanded && items.length > 0 && (
        <ItemList>
          {items.map((item, index) => (
            <ItemRow key={item.itemId}>
              <ItemMeta>
                <ItemTitle>{intl.formatMessage(messages.item, { index: index + 1 })}</ItemTitle>
                <ItemUrn>{item.itemId}</ItemUrn>
              </ItemMeta>
              <TagGroup>
                <Tag>{item.activity?.activityType}</Tag>
                <Tag>{item.scoringMode}</Tag>
                <PrimaryTag>
                  {intl.formatMessage(messages.pointsCount, { count: item.points })}
                </PrimaryTag>
              </TagGroup>
            </ItemRow>
          ))}
        </ItemList>
      )}
    </AssessmentItem>
  );
};

AssessmentRow.propTypes = {
  assessment: PropTypes.shape({
    assessmentId: PropTypes.string.isRequired,
    assessmentType: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  items: PropTypes.array.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default AssessmentRow;
